module.exports = __webpack_public_path__ + "static/media/teygja_innanverdlaeri.873cfabb.png";